import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOptions, XHRBackend } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap';
// import { NgxImageZoomModule } from 'ngx-image-zoom';
import { HttpService } from './http/http.service';
import { httpServiceFactory } from './factories';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { FlashMessagesService } from './../shared/flash-messages/flash-messages.service';
import { ScrollToTopService } from '../shared/scroll-top/scroll-to-top.service';
import { DayPluralPipe, AddS3Path, DateFormatPipe, Greater100, EnumKeyValueListPipe, CampaignStatus, convertToPositivePipe, TextConvertPipe, SafeHtmlPipe } from './../core.pipes';
import {AppFooterComponent} from '../shared/components/UI/app-footer-component' ;

@NgModule({
  declarations: [
    LoaderComponent,
    ConfirmDialogComponent,
    DayPluralPipe, AddS3Path, DateFormatPipe, Greater100, EnumKeyValueListPipe, CampaignStatus, convertToPositivePipe, TextConvertPipe, SafeHtmlPipe, AppFooterComponent
  ],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    // NgxImageZoomModule
  ],
  exports: [
    LoaderComponent,
    ConfirmDialogComponent,
    DayPluralPipe, AddS3Path, DateFormatPipe, Greater100, EnumKeyValueListPipe, CampaignStatus, convertToPositivePipe, TextConvertPipe, SafeHtmlPipe, AppFooterComponent
  ],
  providers: [
    FlashMessagesService,
    LoaderService,
    ScrollToTopService,
    {
      provide: HttpService,
      useFactory: httpServiceFactory,
      deps: [XHRBackend, RequestOptions, LoaderService]
    }
  ]
})
export class SharedModule { }
